module.exports = {
    'desc' : require('./desc'),
    'info' : require('./info'),
    'list' : require('./list'),
    'type' : require('./type'),
}